import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const legacyJsdSettingsLanguageRoute: InvariantJiraRoute = {
	name: 'legacy-jsd-settings-language',
	path: '/servicedesk/admin/:projectKey/language',
	exact: true,
};
